import { s3CloudFrontUrlEndpoint } from '..';

export const defaultItemThumbnail = '/images/default-item-thumbnail.svg';

export const completeImg = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/buynow_complete.svg`;

export const left_chevron_32x32 =
  'https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/left-chevron-32x32.svg';
export const right_chevron_32x32 =
  'https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/right-chevron-32x32.svg';

export const channelTalkIconBrandBg = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/channel-talk/channel-talk-before-cancel.svg`;
export const channelTalkIconGrayBg = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/before-pause-230728/4.svg`;
export const standardBoxImg = `${s3CloudFrontUrlEndpoint}/buynow/One/Group_4666__1__LEy4O4hDz.png`;
export const jumboBoxImg = `${s3CloudFrontUrlEndpoint}/buynow/One/Group_4666__2__e1HU7LL0G.png`;
export const checkedIcon = `${s3CloudFrontUrlEndpoint}/buynow/One/Group_4400_gqV1pYsuh.svg`;
export const uncheckedIcon = `${s3CloudFrontUrlEndpoint}/buynow/One/Ellipse_19_sdzRgffys.svg`;
export const rightChevronIcon = `${s3CloudFrontUrlEndpoint}/buynow/One/Vector_6_glTm6KLoR.svg`;
export const activeRightChevronIcon = `${s3CloudFrontUrlEndpoint}/buynow/One/Vector_6__1__L3hUZPsXp.svg`;

export const hashtagRemoveIcon = `${s3CloudFrontUrlEndpoint}/recipe/hashtag-close-icon_s7jpD7Q3_.svg`;
export const defaultProfilePhoto = `${s3CloudFrontUrlEndpoint}/mypage/Creator/default-profile_PnIgO32LT.svg`;

export const searchGray700Icon = `${s3CloudFrontUrlEndpoint}/svg/Search-icon-24x-24_qnmx4o57C.svg`;
export const search_gray300_24x24 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/search_gray300_24x24.svg`;
export const checkIcon = `${s3CloudFrontUrlEndpoint}/svg/check-brand-color_Sao6yu6iV.svg`;
export const checkGrayIcon = `${s3CloudFrontUrlEndpoint}/svg/check-gray-color_kO8ufT5vW.svg`;
export const crossGrayIcon = `${s3CloudFrontUrlEndpoint}/svg/cross-gray-300-icon_KZBSoO6xj.svg`;
export const emptyHeartIcon = `${s3CloudFrontUrlEndpoint}/Diary/Vector__11__IHZSNmZxo.svg`;
export const fillHeartIcon = `${s3CloudFrontUrlEndpoint}/Diary/Vector__12__75ZffCgjq.svg`;

export const bookmarkPushIcon = `${s3CloudFrontUrlEndpoint}/svg/bookmark-push_mXCuKPWnTP.svg`;
export const commentPushIcon = `${s3CloudFrontUrlEndpoint}/svg/comment-push_XiS7WWAXM.svg`;
export const heartPushIcon = `${s3CloudFrontUrlEndpoint}/svg/heart-push_O6Lf6yOK1x.svg`;
export const spoonPushIcon = `${s3CloudFrontUrlEndpoint}/svg/spoon-push_TXmuoa0Cz.svg`;
export const plusIcon = `${s3CloudFrontUrlEndpoint}/svg/plus-icon.svg`;
export const minusIcon = `${s3CloudFrontUrlEndpoint}/svg/minus-icon_wsfQkVFlb.svg`;
export const greenCheckIcon = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/buynow/Three/Group_4690_ZmvaYWLxI.svg`;
export const warningSignIcon = `${s3CloudFrontUrlEndpoint}/mypage/Creator/Frame_4747__1__8eHPfbDeF.svg`;
export const uncheckedRadioIcon = `${s3CloudFrontUrlEndpoint}/ustore/unchecked-radio-icon.svg`;
export const checkedRadioIcon = `${s3CloudFrontUrlEndpoint}/ustore/checked-radio-icon.svg`;
export const closeGray300Icon = `${s3CloudFrontUrlEndpoint}/ustore/close-gray-icon.svg`;
export const chattingIcon = `${s3CloudFrontUrlEndpoint}/mypage/order-history/Group_4965_JyG7pdOkT.svg`;
export const cameraIcon = `${s3CloudFrontUrlEndpoint}/mypage/order-history/Vector_Yk5riWW3z.svg`;
export const filledStarIcon = `${s3CloudFrontUrlEndpoint}/mypage/order-history/Vector__26__enBGagMTM.svg`;
export const emptyStarIcon = `${s3CloudFrontUrlEndpoint}/mypage/order-history/empty-star.svg`;
export const discountIcon = `${s3CloudFrontUrlEndpoint}/svg/discount-bottom-arrow_GysDhNTWx.svg`;
export const shareIcon = `${s3CloudFrontUrlEndpoint}/svg/share-icon_eVilpnXvD.svg`;
export const discountArrowIcon = `${s3CloudFrontUrlEndpoint}/ustore/discount-arrow.svg`;
export const shareGrayIcon = `${s3CloudFrontUrlEndpoint}/svg/share-icon-gray_rl4TXrLLw.svg`;
export const productDefaultThumbnail = `${s3CloudFrontUrlEndpoint}/ustore/producer-default-thumbnail_gAgcQgYM6.svg`;
export const whiteXIcon = `${s3CloudFrontUrlEndpoint}/reviews/white-x.svg`;
export const zoomIcon = `${s3CloudFrontUrlEndpoint}/svg/zoom.svg`;
export const whiteThunderIcon = `${s3CloudFrontUrlEndpoint}/svg/emergency-rescue-icon_4WCPmFRqj.svg`;
export const emergencySavingIcon = `${s3CloudFrontUrlEndpoint}/svg/emergency-rescue-icon_4WCPmFRqj.svg`;
export const arrowBottomWhite = `${s3CloudFrontUrlEndpoint}/svg/arrow-bottom-white_OCLCnCiwK.svg`;
export const gray600NewButtonIcon = `${s3CloudFrontUrlEndpoint}/buynow/One/Frame_5051_gYIcxV4Yn.svg`;

export const gray500InfoIcon = `${s3CloudFrontUrlEndpoint}/svg/gray-500-information.svg`;
export const gray600ChevronIcon = `${s3CloudFrontUrlEndpoint}/svg/gray-600-chevron-right_5qBS9q-mc.svg`;
export const orange300ChevronIcon = `${s3CloudFrontUrlEndpoint}/svg/Vector_exvQGdKHZ.svg`;
export const whiteChevronIcon = `${s3CloudFrontUrlEndpoint}/svg/Vector__1__f1EYav5Us.svg`;
export const gray700ChevronIcon = `${s3CloudFrontUrlEndpoint}/svg/right-arrow-gray-700_5WbBGEvwI.svg`;
export const moDiaryInfoBubble = `${s3CloudFrontUrlEndpoint}/svg/mo-diary-info-bubble-2.svg`;
export const pcDiaryInfoBubble = `${s3CloudFrontUrlEndpoint}/svg/pc-diary-info-bubble-2.svg`;
export const crossGray300Icon = `${s3CloudFrontUrlEndpoint}/svg/cross-gray-300-icon_KZBSoO6xj.svg`;
export const whiteRightChevronIcon = `${s3CloudFrontUrlEndpoint}/svg/white-right-chevron.svg`;
export const whiteCheckIcon = `${s3CloudFrontUrlEndpoint}/svg/white-check_Nj-OXfvUR.svg`;

export const notificationBadgeIcon = `${s3CloudFrontUrlEndpoint}/svg/notification-badge_vglsTNBIO.svg`;
export const gray200ChevronIcon = `${s3CloudFrontUrlEndpoint}/svg/gray200-chevron-left_cx3sS7pW4.svg`;
export const gray400ChevronIcon = `${s3CloudFrontUrlEndpoint}/svg/gray400-chevron-right_UDDtZx4oX.svg`;
export const triangleGray300Icon = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/triangle_gray_300.svg`;
export const triangleGray800Icon = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/triangle_gray_800.svg`;

export const plusGray700_24x24 = `${s3CloudFrontUrlEndpoint}/svg/plus-gray700-24x24_OHHHXdEAj.svg`;

export const checkbox_brand_white_24x24 = `${s3CloudFrontUrlEndpoint}/svg/checkbox-brand-white-24x24_goMzEMrMT.svg`;
export const checkbox_gray300_white_24x24 = `${s3CloudFrontUrlEndpoint}/svg/checkbox-gray300-white-24x24_DdIv3FCZ2.svg`;
export const checkbox_gray200_white_24x24 = `${s3CloudFrontUrlEndpoint}/svg/checkbox-gray200-white-24x24.svg`;
export const checkbox_white_gray100_24x_24 = `${s3CloudFrontUrlEndpoint}/svg/checkbox-white-gray100-24x24_9NFLZ52HE.svg`;
export const checkbox_rounded_brand_white_24x24 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/checkbox/checkbox-brand-white.svg`;
export const checkbox_rounded_gray200_white_24x24 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/checkbox/checkbox-gray200-white.svg`;
export const checkbox_rounded_gray300_gray200_24x24 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/checkbox/checkbox-gray300-gray200.svg`;
export const checkbox_rounded_white_gray200_24x24 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/checkbox/checkbox-white-gray200.svg`;
export const checkbox_rounded_gray200_gray300_24x24 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/checkbox/checkbox_rounded_gray200_gray300_24x24.svg`;

export const check_white_12x7 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/check_white_12x7.svg`;

export const filter_gray400_24x24 = `${s3CloudFrontUrlEndpoint}/svg/filter-gray400-24x24_xCHq2NB8K.svg`;
export const filter_gray800_24x24 = `${s3CloudFrontUrlEndpoint}/svg/filter-gray800-24x24_J_Zd6sC-o.svg`;

export const creator_certificate_12x12 = `${s3CloudFrontUrlEndpoint}/svg/creator_certificate_12x12.svg`;
export const camera_gray600_16x14 = `${s3CloudFrontUrlEndpoint}/svg/camera_gray600_16x14.svg`;
export const camera_gray600_30x30 = `${s3CloudFrontUrlEndpoint}/svg/camera_gray600_30x30.svg`;

export const heart_outline_white_30x30 = `${s3CloudFrontUrlEndpoint}/svg/heart_outline_white_30x30.svg`;
export const heart_outline_gray700_30x30 = `${s3CloudFrontUrlEndpoint}/svg/heart-gray700-30x30_9uYnsjFJp.svg`;
export const hear_filled_brand_30x30 = `${s3CloudFrontUrlEndpoint}/svg/heart-brand-30x30_6GQM1pwuk.svg`;
export const three_dots_menu_gray700_30x30 = `${s3CloudFrontUrlEndpoint}/svg/more_t1UyKSdfi.svg`;
export const right_arrow_gray800_24x24 = `${s3CloudFrontUrlEndpoint}/svg/arrow-left-gray800_24x24_11cmNEpI-.svg`;
export const right_arrow_white_30x30 = `${s3CloudFrontUrlEndpoint}/svg/right_arrow_white_30x30.svg`;

export const heart_outline_gray700_20x20 = `${s3CloudFrontUrlEndpoint}/svg/heart_outline_gray700_20x20_A4U1egDAL.svg`;
export const noti_new_24x24 = `${s3CloudFrontUrlEndpoint}/svg/noti_new_24x24_nKP-J2kzK.svg`;
export const noti_nomal_20x20 = `${s3CloudFrontUrlEndpoint}/svg/noti_nomal_20x20_KFCCjMcRO.svg`;
export const comment_gray800_24x24 = `${s3CloudFrontUrlEndpoint}/svg/comment_gray800_24x24_2UE3v5KOo.svg`;
export const search_brand1_24x24 = `${s3CloudFrontUrlEndpoint}/svg/search_brand1_24x24.svg`;
export const channel_talk_v4_95x105 = `${s3CloudFrontUrlEndpoint}/svg/channel_talk_v4.svg`;
export const myPage_white_24x24 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/mypage_white_24x24.svg`;

export const ExclamationIcon = {
  gray600: {
    '14x14': `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/Exclude.svg`,
  },
};

/**
 * plus
 */
export const PlusIcon = {
  option: {
    '24x24':
      'https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/option-plus-24x24.svg',
  },
};

/**
 * chevron
 */
export const chevron_right_gray400_10x18 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/chevron/chevron_right_gray400_10x18.svg`;
export const chevron_top_gray700_24x24 = `${s3CloudFrontUrlEndpoint}/svg/chevron_top_gray700_24x24.svg`;
export const chevron_bottom_gray700_24x24 = `${s3CloudFrontUrlEndpoint}/svg/chevron-bottom-gray700-24x24_yGjDzkToX.svg`;
export const chevron_right_gray700_24x24 = `${s3CloudFrontUrlEndpoint}/svg/chevron-right-gray700-24x24_Rni5cVM2l.svg`;
export const chevron_right_gray600_8x14 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/chevron/chevron_right_gray600_8x14.svg`;
export const chevron_right_white_9x14 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/chevron_white_right.svg`;

export const ChevronIcon = {
  gray700: {
    bottom_24x24: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/chevron_bottom_gray700_24x24.svg`,
    bottom_30x30:
      'https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/manual/chevron_gray700_30x30.svg',
  },
};

/**
 * comment
 */
export const CommentIcon = {
  white: {
    outline_32x32:
      'https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/comment_white_32x32.svg',
  },
};

/**
 * Bookmark
 */
export const BookmarkIcon = {
  brand: {
    filled_20x20: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/bookmark_brand1_20x20.svg`,
  },
  white: {
    filled_48x48: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/bookmark-white-filled-48x48_YhT78Tv8w.svg`,
    outline_48x48: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/bookmark-white-outline-48x48_Aski8uG2D.svg`,
    outline_40x40: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/recipe/bookmark_white_40x40.svg`,
    filled_36x36: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/bookmark-white-filled-30x30_rJcYuuItu.svg`,
    outline_36x36: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/bookmark-white-outline-30x30_yCJ8OfNJA.svg`,
  },
  gray600: {
    filled_20x20: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/bookmark_gray600_20x20(1).svg`,
  },
} as const;

export const NewBadgeIcon = {
  brand: {
    rounded_11x11: `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/noti/new_badge_brand1_11x11.svg`,
  },
} as const;

export const CrossIcon = {
  gray300: {
    '24x24': `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/cross/cross_gray300_24x24.svg`,
  },
} as const;

export const Setting = {
  gray700: {
    '24x24':
      'https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/setting-gray700-24x24.svg',
  },
};

export const CheckIcon = {
  brandGreen13: {
    brandGreen11_32x32:
      'https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/manual/check_brandGreen11_brandGreen13_32x32.svg',
  },
} as const;

/**
 * cross
 */
export const close_white_12x12 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/close_white_12x12.svg`;
export const close_gray800_12x12 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/close_gray800_12x12.svg`;

export const notice_gray800_14x14 = `https://uglyus.s3.ap-northeast-2.amazonaws.com/assets/svg/Frame+4747.svg`;

export const WHITE = '#FFF';
